import { Injectable } from "@angular/core";
import { Model_Datasource, AbsPaginatedGrid } from 'src/app/app.models';
import { Guid } from 'guid-typescript';
import * as moment from 'moment';
import { PlatformResult, API_RESULT_STATUS } from '../../platform/platform.service';
import { DatasourceOfflineDao } from './datasource-offline.dao';

export interface DatasourceApi {
    doSyncDatasourcesAction(_datasourcesRaw: string);
    onDatasourcesSynced(_result: PlatformResult);

    doClearDatasourcesAction();
    onDatasourcesCleared(_result: PlatformResult);

    doGetDatasourcesAction();
    onDatasourcesFetched(_result: PlatformResult);

    doInsertDatasourcesAction(datasourcesRaw: string);
    onDatasourcesInserted(_result: PlatformResult);

    doSaveDatasourceAction(datasource: string);
    onDatasourceSaved(result: PlatformResult);

    doGetDatasourceAction(numDatasource: string);
    onDatasourceFetched(result: PlatformResult);

    doBuildDatasourceByNumAction(numDatasource: string);
    onDatasourceBuilded(result: PlatformResult);
}

@Injectable()
export class DatasourcesOfflineAndroidDao extends DatasourceOfflineDao {
    constructor() {
        super();
    }

    doSyncDatasourcesAction(_datasources: Model_Datasource[]): Promise<void> {
        return new Promise((resolve, reject) => {
            window['DatasourceApi'].onDatasourcesSynced = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourcesSynced;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            _datasources.forEach((datasource, index, datasources) => datasources[index].SYNCED = true);
            datasourceApi.doSyncDatasourcesAction(JSON.stringify(_datasources))
        });
    }

    doClearDatasourcesAction() {
        return new Promise<void>((resolve, reject) => {
            window['DatasourceApi'].onDatasourcesCleared = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourcesCleared;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            datasourceApi.doClearDatasourcesAction()
        });
    }

    doGetDatasourcesAction(): Promise<Model_Datasource[]> {
        return new Promise<Model_Datasource[]>((resolve, reject) => {
            window['DatasourceApi'].onDatasourcesFetched = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourcesFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            datasourceApi.doGetDatasourcesAction()
        });
    }

    doInsertDatasourcesAction(_datasources: Model_Datasource[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window['DatasourceApi'].onDatasourcesInserted = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourcesInserted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            datasourceApi.doInsertDatasourcesAction(JSON.stringify(_datasources));
        });
    }

    doSaveDatasourceAction(_datasource: Model_Datasource): Promise<Model_Datasource> {
        return new Promise((resolve, reject) => {
            window['DatasourceApi'].onDatasourceSaved = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourceSaved;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            _datasource.GUID_SYNCHRONISATION = Guid.create().toString();
            _datasource.DATE_MODIFICATION = moment().format();
            _datasource.SYNCED = false;
            datasourceApi.doSaveDatasourceAction(JSON.stringify(_datasource));
        });
    }

    doGetDatasourceAction(_numDatasource: string): Promise<Model_Datasource> {
        return new Promise((resolve, reject) => {
            /*window['DatasourceApi'].onDatasourceFetched = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourceFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };*/
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            const rawResult = datasourceApi.doGetDatasourceAction(_numDatasource);
            resolve(JSON.parse(rawResult));
        });
    }

    doBuildDatasourceByNumAction(_num: string) {
        return new Promise<AbsPaginatedGrid<any>>((resolve, reject) => {
            /*window['DatasourceApi'].onDatasourceBuilded = (_result: PlatformResult) => {
                delete window['DatasourceApi'].onDatasourceBuilded;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };*/
            const datasourceApi: DatasourceApi = window['DatasourceApi'];
            const rawResult = datasourceApi.doBuildDatasourceByNumAction(_num);
            resolve(JSON.parse(rawResult));
        });
    }
}
